import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import useStyles from '../styles';
import { StudentRelevantInfo } from '../types';
import { getLeadSourceLabel } from '../../../utils/leadSource';

function RelevantInfo({ studentRelevantInfo }: { studentRelevantInfo?: StudentRelevantInfo }) {
  const classes = useStyles();

  return (
    <Box className={classes.relevantInfoContainer}>
      <Box className={classes.card}>
        <Typography className={classes.cardTitle}>
          Áreas de interés
        </Typography>
        <Divider />
        <Box className={classes.innerSection}>
          <Box>
            <Typography className={classes.innerSectionTitle}>
              Asignaturas:
            </Typography>
            {studentRelevantInfo?.testsToTake.map((test) => (
              <Box key={test.id}>
                <Typography className={classes.innerSectionText}>
                  {test.name}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <Box>
          <Typography className={classes.innerSectionTitle}>
            Objetivos:
          </Typography>
          <Typography className={classes.innerSectionText}>
            {studentRelevantInfo?.testsComment || 'No hay objetivos específicos'}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.card}>
        <Typography className={classes.cardTitle}>
          Sede y nivel a cursar
        </Typography>
        <Divider />
        <Box className={classes.innerSection} sx={{ flexWrap: 'wrap', alignItems: 'flex-start' }}>
          <Box sx={{ flex: '0 0 45%' }}>
            <Typography className={classes.innerSectionTitle}>
              Sede:
            </Typography>
            {studentRelevantInfo?.locationName
              ? studentRelevantInfo.locationName.split(',').map((sede, i) => (
                <Typography key={i} className={classes.innerSectionText}>
                  - {sede.trim()}
                </Typography>
              ))
              : <Typography className={classes.innerSectionText}>-</Typography>
            }
          </Box>
          <Box sx={{ flex: '0 0 45%' }}>
            <Typography className={classes.innerSectionTitle}>
              Nivel:
            </Typography>
            <Typography className={classes.innerSectionText}>
              {studentRelevantInfo?.classYear || '-'}
              - {studentRelevantInfo?.inscriptionYear}
            </Typography>
          </Box>
          <Box sx={{ flex: '0 0 45%' }}>
            <Typography className={classes.innerSectionTitle}>
              Colegio:
            </Typography>
            <Typography className={classes.innerSectionText}>
              {studentRelevantInfo?.schoolName || '-'}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box className={classes.card}>
        <Typography className={classes.cardTitle}>
          ¿Cómo nos conociste?
        </Typography>
        <Divider />
        <Box className={classes.innerSection}>
          <Box>
            <Typography className={classes.innerSectionTitle}>
              Relación:
            </Typography>
            <Typography className={classes.innerSectionText}>
              {getLeadSourceLabel(studentRelevantInfo?.relationToStudent)}
            </Typography>
          </Box>
          {(studentRelevantInfo?.leadName || studentRelevantInfo?.ambassadorCode) && <Box>
            <Typography className={classes.innerSectionTitle}>
              {studentRelevantInfo?.leadName ? 'Nombre:' : 'Código de referido:'}
            </Typography>
            <Typography className={classes.innerSectionText}>
              {studentRelevantInfo?.leadName || studentRelevantInfo?.ambassadorCode || '-'}
            </Typography>
          </Box>}
        </Box>
      </Box>
    </Box>
  );
}

export default RelevantInfo;
